import fi_FI from '../../date-picker/locale/fi_FI'
export default fi_FI



// WEBPACK FOOTER //
// ./components/calendar/locale/fi_FI.js